import React from 'react';

const fallbackStyle: React.CSSProperties = {
  width: '100vw',
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#ffffff',
  background: 'linear-gradient(0deg, black, #1d2f44)',
  fontFamily: 'Lato, sans-serif',
  fontSize: '16px',
};

export const StartupLoadingScreen = () => <div style={fallbackStyle}>Loading...</div>;

export class StartupErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Startup render error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            ...fallbackStyle,
            padding: '24px',
            textAlign: 'center',
          }}
        >
          MuseFlow could not finish starting. Please close and reopen the app.
        </div>
      );
    }

    return this.props.children;
  }
}
